import { render, staticRenderFns } from "./SkillSimSkillTree.vue?vue&type=template&id=dd1cac70&scoped=true&"
import script from "./SkillSimSkillTree.vue?vue&type=script&lang=ts&"
export * from "./SkillSimSkillTree.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSimSkillTree.vue?vue&type=style&index=0&id=dd1cac70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1cac70",
  null
  
)

export default component.exports